import { Modal } from 'bootstrap';
import BaseComponent from '../../../../../common/js/BaseComponent';
import Helper from '../../../../../common/utils/helper';

export default class ColorCard extends BaseComponent {
    colorModalElement: HTMLElement | null;

    colorModalInstance: Modal | null;

    init(): void {
        this.initEvents();
    }

    initEvents() {
        this.view.addEventListener('click', () => {
            this.displayModalViewProducts();
        });
    }

    private displayModalViewProducts() {
        fetch('/categories/getProductsForColor', {
            method: 'POST',
            headers: Helper.createFetchHeader(),
            body: JSON.stringify({
                products: this.view.getAttribute('data-products'),
                color: this.view.getAttribute('data-color'),
            }),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                this.createModal(data);
            });
    }

    private createModal(data: string) {
        // On inject ma modal dans mon DOM
        document.body.insertAdjacentHTML('beforeend', data);
        // On va récupérer la modal précédement injectée
        this.colorModalElement = document.getElementById('color-modal');
        // On vérifie que la modal existe bien
        if (this.colorModalElement) {
            this.onColorModalHide();
            // On affiche ma modale
            this.colorModalInstance = window.bootstrap.Modal.getOrCreateInstance(this.colorModalElement);
            this.colorModalInstance.show();
        }
    }

    private onColorModalHide() {
        if (this.colorModalElement != null) {
            this.colorModalElement.addEventListener('hidden.bs.modal', () => {
                this.colorModalElement?.remove();
                this.colorModalInstance = null;
            });
        }
    }
}
